import React, { useState } from "react";
import { Button, message } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

const Logout = ({
  darkMode,
  collapsed,
  screens,
  theme,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);

      await api.post("api/logout/");

      // Clear auth storage
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      localStorage.removeItem("user");

      sessionStorage.clear();

      message.success("Logged out successfully");

      navigate("/");
      // or navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);

      message.error(
        error?.response?.data?.detail ||
          "Logout failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      danger
      block
      size="large"
      loading={loading}
      icon={<LogoutOutlined />}
      onClick={handleLogout}
      style={{
        borderRadius: 14,
        height: 48,

        background: darkMode
          ? "rgba(255,255,255,0.04)"
          : "#ffffff",

        border: darkMode
          ? "1px solid rgba(255,255,255,0.08)"
          : `1px solid ${theme.border}`,

        fontWeight: 600,
      }}
    >
      {(!collapsed || !screens.md) &&
        "Logout"}
    </Button>
  );
};

export default Logout;